import React from 'react';
import { useHistory, Route } from 'react-router-dom';
import { Button, Card, Page, Typography } from 'seagull';
import styles from "./Reports.module.scss";
import { routes } from "../../constants";
import { RevenueBreakdownReport } from "./RevenueBreakdown/RevenueBreakdown";
import { ActiveServicesReport } from "./ActiveServices/ActiveServices";
import { RemainingCreditReport } from "./RemainingCredit/RemainingCredit";
function ReportCard(props) {
  const {
    title,
    description,
    url,
    testId
  } = props;
  const history = useHistory();
  return /*#__PURE__*/React.createElement(Card, {
    className: styles.reportCard,
    autoHeight: true
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.reportCardDetails
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    weight: "bold"
  }, title), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1"
  }, description)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "report-card-".concat(testId, "-navigate"),
    onClick: () => history.push(routes.reports + url)
  }, "Go to report")));
}
function AllReports() {
  return /*#__PURE__*/React.createElement(Page, {
    header: "All Reports",
    "data-testid": "all-reports-screen"
  }, /*#__PURE__*/React.createElement(ReportCard, {
    title: "Revenue Breakdown",
    description: "Review historical revenue with detailed breakdowns across various time intervals. This revenue data is based on paid invoices and accounts for any refunds and disputes, if applicable. Note that the revenue data does not include any platform fees.",
    url: "/revenue",
    testId: "revenue"
  }), /*#__PURE__*/React.createElement(ReportCard, {
    title: "Active Services",
    description: "View all active services across all of your agreements with options to apply various filters.",
    url: "/active-services",
    testId: "active-services"
  }), /*#__PURE__*/React.createElement(ReportCard, {
    title: "Remaining Credit",
    description: "View the remaining credit your clients have per agreement.",
    url: "/remaining-credit",
    testId: "remaining-credit"
  }));
}
export function Reports() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Route, {
    path: routes.reports,
    exact: true,
    key: "all-reports",
    render: () => /*#__PURE__*/React.createElement(AllReports, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.revenueReport,
    exact: true,
    key: "revenue-report",
    render: () => /*#__PURE__*/React.createElement(RevenueBreakdownReport, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.activeServicesReport,
    exact: true,
    key: "active-services-report",
    render: () => /*#__PURE__*/React.createElement(ActiveServicesReport, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.remainingCreditReport,
    exact: true,
    key: "remaining-credit-report",
    render: () => /*#__PURE__*/React.createElement(RemainingCreditReport, null)
  }));
}